import { EditableComponent } from '@adobe/aem-react-editable-components';
import { StyledGolfBioCardsContainer } from './GolfBioCardsContainer.styles';
import clsx from 'clsx';
import { BioCard } from './BioCard/BioCard';
import { GolfBioCardsProps } from './GolfBioCardsContainer.types';
import { fullbleedClass } from '../../modules/utils/constants/constants';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const GolfBioCardsContainer = (props: GolfBioCardsProps) => {
  return props?.bioDetails && props?.bioDetails?.length > 0 ? (
    <StyledGolfBioCardsContainer className={clsx(props?.styleclass || 'alternate')}>
      <div
        className={clsx('bio-cards-container container d-flex flex-column', {
          'px-md-0': props?.styleclass?.includes(fullbleedClass),
          'p-0': !props?.styleclass?.includes(fullbleedClass),
        })}
      >
        {props?.bioDetails?.map(card => (
          <BioCard {...card} {...props} />
        ))}
      </div>
    </StyledGolfBioCardsContainer>
  ) : null;
};

export const GolfBioCardsContainerConfig = {
  emptyLabel: 'biocardscomponent',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/golf/biocardscomponent`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GolfBioCardsContainerEditable = (props: any) => (
  <EditableComponent config={GolfBioCardsContainerConfig} {...props}>
    <GolfBioCardsContainer {...props} />
  </EditableComponent>
);
